import React from 'react';
export const CancellationPolicy = () => {
  return <div className="w-full" data-id="element-196">
      {/* Header */}
      <div className="bg-primary py-16 w-full" data-id="element-197">
        <div className="container mx-auto px-4" data-id="element-198">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-199">
            Cancellation Policy
          </h1>
          <p className="text-xl text-white/90" data-id="element-200">
            Information about cancelling your service plan with Prismedge
          </p>
        </div>
      </div>
      {/* Content */}
      <section className="py-16 bg-light" data-id="element-201">
        <div className="container mx-auto px-4" data-id="element-202">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-203">
            <h2 className="text-2xl font-bold text-primary mb-6" data-id="element-204">
              Cancellation Policy & Exclusions
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-205">
              At Prismedge, your satisfaction with our service plans is our
              priority. We understand that circumstances can change, so we offer
              a simple and transparent cancellation process to give you peace of
              mind.
            </p>
            <div className="space-y-8" data-id="element-206">
              <div data-id="element-207">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-208">
                  Cancellation Within 14 Days
                </h3>
                <p className="text-gray-600" data-id="element-209">
                  You have the right to cancel your service plan within 14 days
                  of purchase. If you cancel within this period, you'll receive
                  a full refund—no questions asked. This cooling-off period lets
                  you review your plan to ensure it meets your needs.
                </p>
              </div>
              <div data-id="element-210">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-211">
                  Cancellation After 14 Days and Within 28 Days
                </h3>
                <p className="text-gray-600" data-id="element-212">
                  If you decide to cancel after the initial 14-day period but
                  within 28 days from purchase, you may be eligible for a
                  partial refund. This refund is granted at Prismedge's
                  discretion, considering any services or repairs already
                  provided under your plan.
                </p>
              </div>
              <div data-id="element-213">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-214">
                  No Cancellations or Refunds After 28 Days
                </h3>
                <p className="text-gray-600" data-id="element-215">
                  Cancellations and refunds cannot be processed after 28 days
                  from the purchase date. Please review your plan carefully and
                  contact us promptly if you have any concerns or need
                  assistance.
                </p>
              </div>
              <div data-id="element-216">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-217">
                  How to Cancel Your Service Plan
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-218">
                  To cancel your plan, please contact our customer support team
                  using the following:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-219">
                  <li data-id="element-220">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-primary hover:underline" data-id="element-221">
                      0800 055 4969
                    </a>
                  </li>
                  <li data-id="element-222">
                    Email:{' '}
                    <a href="mailto:rawalraj2057@gmail.com" className="text-primary hover:underline" data-id="element-223">
                      rawalraj2057@gmail.com
                    </a>
                  </li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-224">
                  Once we receive your cancellation request, we'll review your
                  case promptly. If eligible, your refund will be processed
                  quickly, and you'll receive confirmation when your
                  cancellation and refund are complete.
                </p>
              </div>
              <div data-id="element-225">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-226">
                  Refund Processing
                </h3>
                <p className="text-gray-600" data-id="element-227">
                  All refunds are made to the original payment method used at
                  purchase. For security reasons, we don't process refunds to
                  alternative accounts or payment methods.
                </p>
              </div>
              <div data-id="element-228">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-229">
                  Plan Exclusions and Coverage Limits
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-230">
                  To maintain fairness and service quality, the following are
                  excluded from coverage under your Prismedge plan:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-231">
                  <li data-id="element-232">
                    Pre-existing Faults: Faults or damage present before your
                    plan started are not covered.
                  </li>
                  <li data-id="element-233">
                    Misuse or Neglect: Damage caused by improper use, neglect,
                    accidents, or unauthorized repairs is excluded.
                  </li>
                  <li data-id="element-234">
                    Non-standard Repairs: Repairs beyond normal appliance
                    operation or servicing, including modifications or
                    alterations, are excluded.
                  </li>
                  <li data-id="element-235">
                    Illegal or Fraudulent Use: Any fraudulent or illegal use of
                    our services will result in immediate plan cancellation
                    without refund.
                  </li>
                  <li data-id="element-236">
                    Manufacturer's Guidelines: Appliances not used or maintained
                    as per manufacturer instructions are excluded.
                  </li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-237">
                  If any of these exclusions apply, your plan may be voided
                  immediately, and you'll lose eligibility for repairs or
                  refunds under the plan.
                </p>
              </div>
              <div data-id="element-238">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-239">
                  Need Help?
                </h3>
                <p className="text-gray-600" data-id="element-240">
                  If you have any questions about cancelling your plan or want
                  clarification on coverage, please contact our customer service
                  team. We're here to support you and ensure you understand your
                  options clearly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};